module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/product-images/frat-product-4-4c87cefa7859603d43ef93eae80b1724.jpg";